'use client';

import { mergeClasses, __styles } from '@griffel/react';
const useTableLayoutStyles = /*#__PURE__*/__styles({
  root: {
    mc9l5x: "f1tp1avn"
  }
}, {
  d: [".f1tp1avn{display:table-row-group;}"]
});
const useFlexLayoutStyles = /*#__PURE__*/__styles({
  root: {
    mc9l5x: "ftgm304"
  }
}, {
  d: [".ftgm304{display:block;}"]
});
export const tableBodyClassName = 'fui-TableBody';
export const tableBodyClassNames = {
  root: 'fui-TableBody'
};
/**
 * Apply styling to the TableBody slots based on the state
 */
export const useTableBodyStyles_unstable = state => {
  'use no memo';

  const layoutStyles = {
    table: useTableLayoutStyles(),
    flex: useFlexLayoutStyles()
  };
  state.root.className = mergeClasses(tableBodyClassName, state.noNativeElements ? layoutStyles.flex.root : layoutStyles.table.root, state.root.className);
  return state;
};